import { getReplyThoughtsFromParent } from "../Firebase/ReplyUtilities"
import { TextPost } from "../ReactContexts/PostContext"

export const personHasReplied = async (personId: string, thought: TextPost) => {
  const replies = await getReplyThoughtsFromParent(thought)
  const personsReplies = replies.filter((e) => e.authorId === personId)
  return personsReplies.length > 0
}
